export enum PartCatalogueTreeNodeType {
    None = 'None',
    Brand = 'Brand',
    ModelGroup = 'ModelGroup',
    Model = 'Model',
    Diagram = 'Diagram',
}
